import React, { Component } from 'react';

import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Box, Button, ButtonGroup, Chip, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton } from '@mui/material';
import Global from './Global';
import { Add, AddCircle, CalendarMonth, CalendarToday, RemoveCircle } from '@mui/icons-material';
import DateRangePicker from './DateRangePicker';

class DateRangePickerRich extends Component {
  state = { 
    showDialog: false, 
    startDate: moment(),
    endDate: moment(),
    lastYear: [moment().subtract(1, 'year').startOf("year"), moment().subtract(1, "year").endOf("year")],
    thisYear: [moment().startOf('year'), moment().endOf("year")],
    lastMonth: [moment().subtract(1, 'month').startOf("month"), moment().subtract(1, "month").endOf("month")],
    thisMonth: [moment().startOf('month'), moment().endOf("month")],
    lastWeek: [moment().subtract(1, 'week').startOf("week"), moment().subtract(1, "week").endOf("week")],
    thisWeek: [moment().startOf('week'), moment().endOf("week")],
    yeterday: [moment().subtract(1, 'day'), moment().subtract(1, "day")],
    today: [moment(), moment()],
  } 

  showDialog = () => {
    this.setState({showDialog: true});
  }

  hideDialog = () => {
    this.setState({showDialog: false});
  }

  componentDidMount() {
    this.setState({startDate: this.props.startDate, endDate: this.props.endDate});
  }

  // componentDidUpdate(prevProps, prevState) {
  //   console.log("PREVPROPS", prevProps, "PREVSTATE", prevState);
  // }

  add1Day = () =>{
    this.handleDateChanged([this.state.startDate, this.state.endDate.add(1, "day")]);
    // this.setState({endDate: this.state.endDate.add(1, "day")}, () => {
    //   this.props.onDateChanged([this.state.startDate, this.state.endDate]);
    // });
  }

  sub1Day = () =>{
    this.handleDateChanged([this.state.startDate.subtract(1, "day"), this.state.endDate]);
    // this.setState({startDate: this.state.startDate.subtract(1, "day")}, () => {
    //   this.props.onDateChanged([this.state.startDate, this.state.endDate]);
    // });
  }

  handleDateChanged = (newDateRange) => {
    if(!newDateRange[0] || !newDateRange[1]){
      return;
    }
    console.log("NEWDATERANGE", newDateRange);

    let startDate = newDateRange[0];
    let endDate = newDateRange[1];

    if(!startDate.isAMomentObject){
      startDate = moment(startDate);
    }

    if(!endDate.isAMomentObject){
      endDate = moment(endDate);
    }

    this.setState({startDate: startDate, endDate: endDate}, () => {
      this.props.onDateChanged([this.state.startDate, this.state.endDate]);
      this.hideDialog();
    })
  }

  render() { 
    return (
      <Box>
        <Box>
          <Grid container spacing={1} border={"solid 0px"}>
            {/* <Grid item xs={1}>
              <Box>
                <Box border={"solid 1px"} padding={0}>
                  <RemoveCircle onClick={this.sub1Day} sx={{width: "15px", height: "15px", mt: "0px", cursor: "pointer"}} />
                </Box>
                <Box border={"solid 1px"} padding={0}>
                  <RemoveCircle onClick={this.sub1Day} sx={{width: "15px", height: "15px", mt: "0px", cursor: "pointer"}} />
                </Box>
              </Box>
              
              <RemoveCircle onClick={this.sub1Day} sx={{width: "20px", height: "20px", mt: "8px", cursor: "pointer"}} />
            </Grid> */}
            <Grid item xs={12} textAlign={"center"}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Box onClick={this.showDialog} sx={{border: "solid 1px", borderRadius: "4px", padding: "3px", textAlign: "center", cursor: "pointer"}}>
                    {Global.formatDateTimeToStrFormat(this.state.startDate, "DD-MM-yyyy")} - {Global.formatDateTimeToStrFormat(this.state.endDate, "DD-MM-yyyy")}
                  </Box>
                  {/* <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <ButtonGroup fullWidth orientation="horizontal" size='small' aria-label="Vertical button group" sx={{padding: 0}}>
                        <Button 
                          onClick={() => this.handleDateChanged([this.state.startDate.add(1, "day"), this.state.endDate])} 
                          size='small' 
                          sx={{padding: 0, height: "15px"}}
                        >
                          +
                        </Button>
                        <Button 
                          onClick={() => this.handleDateChanged([this.state.startDate.subtract(1, "day"), this.state.endDate])} 
                          size='small' 
                          sx={{padding: 0, height: "15px"}}
                        >
                          -
                        </Button>
                      </ButtonGroup>
                    </Grid>
                    <Grid item xs={6}>
                      <ButtonGroup fullWidth orientation="horizontal" size='small' aria-label="Vertical button group" sx={{padding: 0}}>
                        <Button 
                          onClick={() => this.handleDateChanged([this.state.startDate, this.state.endDate.add(1, "day")])} 
                          size='small' 
                          sx={{padding: 0, height: "15px"}}
                        >
                          +
                        </Button>
                        <Button 
                          onClick={() => this.handleDateChanged([this.state.startDate, this.state.endDate.subtract(1, "day")])} 
                          size='small' 
                          sx={{padding: 0, height: "15px"}}
                        >
                          -
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid> */}
                </Grid> 
                {/* <Grid item xs={1}>
                  <CalendarMonth />
                </Grid>  */}
              </Grid>
              
            </Grid>
            {/* <Grid item xs={1}>
              <AddCircle onClick={this.add1Day} sx={{width: "20px", height: "20px", mt: "7px", cursor: "pointer"}} />
            </Grid> */}
          </Grid>
          
          
          
        </Box>

        <Dialog fullWidth onClose={this.hideDialog} open={this.state.showDialog}>
          <DialogTitle>{ this.props.title ?? "Setup Date" }</DialogTitle>
          <DialogContent>
            <Divider sx={{mb: "20px"}} />
            <Grid container spacing={1}>
              <Grid item xs={6} textAlign={"center"}>
                <Button 
                  size='small' 
                  sx={{mb: "10px", textTransform: "capitalize"}} 
                  // label={`${this.state.lastYear[0].format("yyyy")} - ${this.state.lastYear[1].format("yyyy")}`} 
                  label={"Last year"}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  onClick={() => {this.handleDateChanged(this.state.lastYear);}} 
                >Last Year</Button>
              </Grid>
              <Grid item xs={6} textAlign={"center"}>
                <Button 
                  size='small' 
                  sx={{mb: "10px", textTransform: "capitalize"}} 
                  // label={`${this.state.thisYear[0].format("DD MMM yyyy")} - ${this.state.thisYear[1].format("DD MMM yyyy")}`} 
                  label={"This Year"}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  onClick={() => {this.handleDateChanged(this.state.thisYear);}} 
                >This Year</Button>
              </Grid>
              <Grid item xs={6} textAlign={"center"}>
                <Button 
                  size='small' 
                  sx={{mb: "10px", textTransform: "capitalize"}} 
                  // label={`${this.state.lastMonth[0].format("DD MMM yyyy")} - ${this.state.lastMonth[1].format("DD MMM yyyy")}`} 
                  label={"Last Month"}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  onClick={() => {this.handleDateChanged(this.state.lastMonth);}} 
                >Last Month</Button>
              </Grid>
              <Grid item xs={6} textAlign={"center"}>
                <Button 
                  size='small' 
                  sx={{mb: "10px", textTransform: "capitalize"}} 
                  // label={`${this.state.thisMonth[0].format("DD MMM yyyy")} - ${this.state.thisMonth[1].format("DD MMM yyyy")}`} 
                  label={"This Month"}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  onClick={() => {this.handleDateChanged(this.state.thisMonth);}} 
                >This Month</Button>
              </Grid>
              <Grid item xs={6} textAlign={"center"}>
                <Button 
                  size='small' 
                  sx={{mb: "10px", textTransform: "capitalize"}} 
                  // label={`${this.state.lastWeek[0].format("DD MMM yyyy")} - ${this.state.lastWeek[1].format("DD MMM yyyy")}`} 
                  label={"Last Week"}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  onClick={() => {this.handleDateChanged(this.state.lastWeek);}} 
                >Last Week</Button>
              </Grid>
              <Grid item xs={6} textAlign={"center"}>
                <Button 
                  size='small' 
                  sx={{mb: "10px", textTransform: "capitalize"}} 
                  // label={`${this.state.thisWeek[0].format("DD MMM yyyy")} - ${this.state.thisWeek[1].format("DD MMM yyyy")}`} 
                  label={"This Week"}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  onClick={() => {this.handleDateChanged(this.state.thisWeek);}} 
                >This Week</Button>
              </Grid>
              <Grid item xs={6} textAlign={"center"}>
                <Button 
                  size='small' 
                  sx={{mb: "10px", textTransform: "capitalize"}} 
                  // label={`${this.state.yeterday[0].format("DD MMM yyyy")} - ${this.state.yeterday[1].format("DD MMM yyyy")}`} 
                  label={"Yesterday"}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  onClick={() => {this.handleDateChanged(this.state.yeterday);}} 
                >Yesterday</Button>
              </Grid>
              <Grid item xs={6} textAlign={"center"}>
                <Button 
                  size='small' 
                  sx={{mb: "10px", textTransform: "capitalize"}} 
                  // label={`${this.state.today[0].format("DD MMM yyyy")} - ${this.state.today[1].format("DD MMM yyyy")}`} 
                  label={"Today"}
                  fullWidth
                  variant='outlined'
                  color='primary'
                  onClick={() => {this.handleDateChanged(this.state.today);}} 
                >Today</Button>
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <Divider sx={{mt: "10px", mb: "10px"}} />
                <Box sx={{mb: "10px", fontSize: "11px"}}>
                  Custom
                </Box>
                <DateRangePicker {...this.props} onDateChanged={this.handleDateChanged} />
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>

      </Box>
    );
  }
}
 
export default DateRangePickerRich;

// function DateRangePickerRichFunction(props){
//     const [dateRange, setDateRange] = React.useState([props.startDate, props.endDate]);
//     const [startDate, endDate] = dateRange;
//     const [message, setMessage] = React.useState("");

//     if(true){
//       return <Box>{startDate} - {endDate}</Box>
//     }

//     return (

//       <>
//         <DatePicker
//           readOnly={false}
//           selectsRange={true}
//           startDate={startDate}
//           endDate={endDate}
//           dateFormat="d-M-yyyy"
//           placeholderText='Filter tanggal'
//           onChange={(update) => {
//             console.log("RANGE", update);
            
//             // if(update[0] !== null && update[1] !== null){
//             //   let startDate = moment(update[0]);
//             //   let endDate = moment(update[1]);
//             //   let diffs = Math.abs(startDate.diff(endDate, "days"));
//             //   console.log("DIFFS", diffs);
//             //   if(diffs > 35){
//             //     setDateRange([null, null]);
//             //     setMessage("Rentang tanggal max 35 hari");
//             //     return
//             //   }
//             // }
            
//             setDateRange(update);
//             setMessage("");
//             // if(update[0] !== null && update[1] !== null){
//               props.onDateChanged(update);
//             // }

//           }}
//           isClearable={true}
//           popperPlacement="top-end"
//           popperModifiers={[
//             {
//               name: "offset",
//               options: {
//                 offset: [5, 10],
//               },
//             },
//             {
//               name: "preventOverflow",
//               options: {
//                 rootBoundary: "viewport",
//                 tether: false,
//                 altAxis: true,
//               },
//             },
//           ]}
//           className='border rounded rounded-lg border-secondary p-2 text-center'
//         />
//         <div className="text-danger">
//           {message}
//         </div>
//       </>
//     );
//   }

  // export default DateRangePickerRich;